import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import DataContext from './context/DataContext';
import './css/index.css';
import './css/globals.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DataContext>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </DataContext>
);

